import { Link } from "react-router-dom";
import React from "react";

export default {
  DrawTab(arr, activeTab, className) {
    return arr.map((item, idx) => {
      return (
        <li
          key={item.redirectURL || item.url || idx}
          className={
            activeTab === (item.activeTab != null ? item.activeTab : idx) + 1
              ? className + "_ipnow"
              : ""
          }
          style={{}}
        >
          <Link to={item.redirectURL || item.url} className="a_ipnow">
            {item.name}
          </Link>
          {Boolean(item.child_Tab?.length) && (
            <>
              <i className="icon_more_arrow_down" />
              <ul className="child_tab_list">
                {item.child_Tab.map((item2) => {
                  return (
                    <li key={item2.url}>
                      <Link to={item2.url}>{item2.name}</Link>
                    </li>
                  );
                })}
              </ul>
            </>
          )}
        </li>
      );
    });
  },
};
